import { Box, Center, chakra, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface Props {
  tooltipId: string;
}

const TooltipQuestionMark: FC<Props> = ({ tooltipId, ...props }) => {
  return (
    <Box
      w="20px"
      h="20px"
      borderRadius="50%"
      data-tooltip-id={tooltipId}
      bgColor="#D9D9D9"
      {...props}
    >
      <Center>
        <Text fontSize="16px" fontWeight={700} color="#fff">
          ?
        </Text>
      </Center>
    </Box>
  );
};

export default chakra(TooltipQuestionMark);
